import { defineTokens } from '@chakra-ui/react/styled-system';

const fontWeights = defineTokens.fontWeights({
  bold: {
    value: 700,
  },
  demiBold: {
    value: 600,
  },
  normal: {
    value: 400,
  },
  semibold: {
    value: 600,
  },
});

export default fontWeights;
